import React from "react";
import { Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import animationData from "../../common_components/request-send-lottie/Request_Send_Lottie.json";
import "./Request_Send_Modal.css";

const Request_Send_Modal = ({ showRequestSent, handleRequestSendClose }) => {
  return (
    <Modal
      show={showRequestSent}
      onHide={handleRequestSendClose}
      centered
      className="request-send-modal"
    >
      <Modal.Body className=" modal-request">
        <div className="modal-card-container text-center">
          <div className="request-circle-icon">
            <Lottie animationData={animationData} loop={true} />
          </div>
          <div className="request-content">
            <h5 className="request-text">Request Sent Successfully</h5>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Request_Send_Modal;
